import React from 'react';
import IconWrapper from '../../../IconWrapper';
const ErrorIconSmall = (props) => (React.createElement(IconWrapper, { size: "small", ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z M8 4a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
export default ErrorIconSmall;
//# sourceMappingURL=ErrorIconSmall.js.map